var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution-boosts-condition"},[_c('select-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.condition,
        'key': 'mode',
        'prefix': 'boosts_condition_',
        'options': _vm.boostsModeOptions,
        'multiple': false,
        'clearable': false,
        'disabled': _vm.disabled
      },
    }}}),_c('number-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.condition,
        'key': 'count',
        'prefix': 'boosts_condition_',
        'min': 0,
        'max': Number.MAX_SAFE_INTEGER,
        'disabled': _vm.disabled
      },
    }}}),(_vm.bindedTarget)?_c('target-card',{staticClass:"mb-2",attrs:{"target":_vm.bindedTarget}}):_vm._e(),_c('config-field',{attrs:{"title":_vm.$t('field_boosts_condition_target_title')}},[_c('a-auto-complete',{staticClass:"target-search w-full mt-2",on:{"select":_vm.selectOption},model:{value:(_vm.targetId),callback:function ($$v) {_vm.targetId=$$v},expression:"targetId"}},[_c('template',{slot:"dataSource"},[(_vm.filteredTargets.length)?_c('a-select-opt-group',{key:_vm.$t('flow_forward_message_sidebar_targets_group_targets')},_vm._l((_vm.filteredTargets),function(opt){return _c('a-select-option',{key:opt.value,attrs:{"value":opt.value.toString()}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),1):_vm._e()],1),_c('a-input',{staticClass:"help",on:{"pressEnter":function($event){!_vm.isAddTargetDisabled ? _vm.addTarget() : false}}},[_c('a-button',{staticClass:"-mr-3",attrs:{"slot":"suffix","icon":"plus","disabled":_vm.isAddTargetDisabled},on:{"click":function($event){return _vm.addTarget()}},slot:"suffix"},[_vm._v(" "+_vm._s(_vm.$t('add'))+" ")])],1)],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }